import { HttpStatusCode } from "axios";
import AppService from "../../apiServices/masters/appService";
import { alertConstants } from "../../helper/sweet-alert";
import { setEmailConfiguration, setEmailConfigurations } from "../../store/slices/master/emailConfigurationSlice";
import emailConfigurationService from "../../apiServices/masters/emailConfigurationService";
import { setEmailBlocks, setUserTypes } from "../../store/slices/common/commonSlice";

export function getEmailConfiguration(id: number) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.getEmailConfiguration(id);
        if (response?.success === true) {
            dispatch(setEmailConfiguration(response.data));
        } else {
            console.log("error");
        }
    };
}

export function getEmailConfigurations(collegeId?: number) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.getEmailConfigurations(collegeId);
        if (response?.success === true) {
            dispatch(setEmailConfigurations(response.data));
        } else {
            console.log("error");
        }
    };
}

export function createEmailConfiguration(data: any, callback: Function) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.createEmailConfiguration(data);
        if (response?.success === true) {
            callback(alertConstants.success);
        } else {
            if (response.status === HttpStatusCode.Conflict) {
                const name = data.name;
                callback(alertConstants.conflict, name);
            } else {
                callback(alertConstants.error);
            }
        }
    };
}

export function updateEmailConfiguration(data: any, id: number, callback: Function) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.updateEmailConfiguration(data, id);
        if (response?.success === true) {
            callback(alertConstants.success);
        } else {
            if (response.status === HttpStatusCode.Conflict) {
                callback(alertConstants.conflict);
            }
            else {
                callback(alertConstants.error);
            }
        }
    };
}


export function deleteEmailConfiguration(id: number, callback: Function) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.deleteEmailConfiguration(id);
        if (response === true) {
            callback(alertConstants.inactiveSuccess);
        } else {
            callback(alertConstants.inactiveFailure);
        }
    };
}
export function getEmailBlockUserTypes(emailBlockId?: number) {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.getEmailBlockUserTypes(emailBlockId);
        if (response?.success === true) {
            dispatch(setUserTypes(response.data));
        } else {
            console.error(response.error);
        }
    };
}

export function getEmailBlocks() {
    return async function (dispatch: any, getState: any) {
        let response = await emailConfigurationService.getEmailBlocks();
        if (response?.success === true) {
            dispatch(setEmailBlocks(response.data));
        } else {
            console.error(response.error);
        }
    };
}